import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { CustomRole } from '../models/customRole';

export class CustomRoleService extends BaseService<CustomRole> {
  override model = CustomRole;
  override modelName = 'customRole';
  override modelLabel = 'Custom Role';

  async create({
    name,
    baseRole,
  }: {
    name: string;
    baseRole: string;
  }): Promise<ApiResponse<CustomRole>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/create`,
      data: { name, baseRole },
    });

    return await this.requestItem(request, CustomRole);
  }
}
